import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { ServiceAdvancedSettings } from './ServiceAdvancedSettings';
export function useServiceAdvancedSettingsAdditionalSection(props) {
    const [serviceAdvancedSettingsRef, setServiceAdvancedSettingsRef] = useState(null);
    return {
        disableBorder: !(serviceAdvancedSettingsRef === null || serviceAdvancedSettingsRef === void 0 ? void 0 : serviceAdvancedSettingsRef.showAdvancedSettings),
        value: /*#__PURE__*/ _jsx(ServiceAdvancedSettings, _object_spread({
            ref: setServiceAdvancedSettingsRef
        }, props), "adv")
    };
}
